import { Icon } from "@iconify/react/dist/iconify.js"
import { useEffect, useRef, useState } from "react"

export default function FilterDropdown({ label, value, options, onChange, valueKey = 'value', labelKey = 'label' }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  const selected = options.find((o) => o?.[valueKey] === value)
  const isActive = false
  // const isActive = value !== options[0].id

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])
  
  return (
    <div className={`filter-drop ${open ? 'filter-drop--open' : ''} ${isActive ? 'filter-drop--active' : ''}`} ref={ref}>
      <button className="filter-drop__trigger" onClick={() => setOpen((v) => !v)}>
        {/* <span className="filter-drop__label">{label}:</span> */}
        <span className="filter-drop__value">{selected?.[labelKey] || selected?.display_name || selected?.name || `All ${label}`}</span>
        <Icon icon="ph:caret-down" height={14} className="filter-drop__caret" />
      </button>

      {open && (
        <div className="filter-drop__menu">
          <button
            key={'all'}
            className={`filter-drop__option ${!value ? 'filter-drop__option--selected' : ''}`}
            onClick={() => { onChange(''); setOpen(false) }}
          >
            All
            {value === '' && <Icon icon="ph:check-circle-fill" height={16} className="filter-drop__check" />}
          </button>
          {options.map((opt) => (
            <button
              key={opt?.[valueKey]}
              className={`filter-drop__option ${value === opt?.[valueKey] ? 'filter-drop__option--selected' : ''}`}
              onClick={() => { onChange(opt?.[valueKey]); setOpen(false) }}
            >
              {opt?.[labelKey] || opt.display_name || opt.name}
              {value === opt?.[valueKey] && <Icon icon="ph:check-circle-fill" height={16} className="filter-drop__check" />}
            </button>
          ))}

        </div>
      )}
    </div>
  )
}